const NotFound = () => {
  return null;
};

export default NotFound;
